export default "/images/background_hochzeit2.png?92a6a5f9acb077a030d4f0d4b9bd7e8b";